'use client';

import { clipCreateProject, clipDeleteProject, clipListProjects, clipUpdateProject } from '@/app/apis';
import { useFetch } from '@/app/hooks';

const PAGE_SIZE = 30;

/** 分页拉取剪辑项目列表（手动触发，用于无限滚动追加） */
export const useListClipProjects = () => {
  const { loading, runAsync: fetchListAsync } = useFetch(
    (page: number) =>
      clipListProjects({
        query: {
          'pager.page': page,
          'pager.pagesz': PAGE_SIZE,
          'pager.order_by': 'created_at',
          'pager.direction': 'backward',
        },
      }),
    { manual: true },
  );
  return { loading, fetchListAsync, pageSize: PAGE_SIZE };
};

export const useCreateClipProject = () => {
  const { loading, runAsync: createAsync } = useFetch(
    (name?: string) => clipCreateProject({ body: name ? { name } : {} }),
    { manual: true },
  );
  return { loading, createAsync };
};

export const useDeleteClipProject = () => {
  const { loading, runAsync: deleteAsync } = useFetch((id: string) => clipDeleteProject({ path: { id } }), {
    manual: true,
  });
  return { loading, deleteAsync };
};

export const useRenameClipProject = () => {
  const { loading, runAsync: renameAsync } = useFetch(
    (id: string, name: string) =>
      clipUpdateProject({
        path: { 'project.id': id },
        query: { mask: 'name' },
        body: { id, name },
      }),
    { manual: true },
  );
  return { loading, renameAsync };
};
